var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExchangeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6416 1.71094L15.5856 2.79019L18.7978 6.00019H3.00056V7.50019H18.7978L15.5863 10.7109L16.6416 11.7894L21.6793 6.75019L16.6416 1.71094ZM7.36031 12.2109L2.32031 17.2502L7.36031 22.2894L8.41481 21.2109L5.20406 18.0002H21.0006V16.5002H5.20331L8.41481 13.2894L7.36031 12.2109Z",
    fill: "#2F80ED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExchangeIcon);
export default __webpack_public_path__ + "static/media/exchangeIcon.ed939e598f5440366fc6697fb32f7e3d.svg";
export { ForwardRef as ReactComponent };